import { Roles } from "@/models/user.model";
import {
  studentLoggedAndIsAuthor,
  studentLoggedAndIsAuthorButTopicIsClosed,
  studentLoggedAndIsNotAuthor,
  teacherOrAdminLoggedAndIsAuthor,
  teacherOrAdminLoggedAndTopicClosed,
  teacherOrAdminLoggedButTopicIsSolved,
  teatcherOrAdminLoggedAndIsNotAuthor,
  topicOptions,
} from "./items-topic-card.utils";
import { StatusTopic } from "@/models/topic.model";

export default class TopicCardDetail {

  public displayTopicOptions(role: Roles, author: boolean, topicStatus: StatusTopic ): Array<topicOptions> {
    switch (role) {
      case Roles.ADMINISTRATOR:
      case Roles.TEACHER:
        if (topicStatus === StatusTopic.CLOSED ){
          return teacherOrAdminLoggedAndTopicClosed;
        } else if (topicStatus === StatusTopic.SOLVED) {
          return teacherOrAdminLoggedButTopicIsSolved;
        } else if (author) {
          return teacherOrAdminLoggedAndIsAuthor;
        } else {
          return teatcherOrAdminLoggedAndIsNotAuthor;
        }
      case Roles.STUDENT:
        if(author && ( topicStatus === StatusTopic.CLOSED || topicStatus === StatusTopic.SOLVED ) ){
          return studentLoggedAndIsAuthorButTopicIsClosed;
        } else if (author) {
          return studentLoggedAndIsAuthor;
        } else {
          return studentLoggedAndIsNotAuthor;
        }
    }

    return [];
  }
}
